module.exports = __webpack_public_path__ + "img/oxford-overview.a702f851.webp";